module.exports = __webpack_public_path__ + "static/img/task-bg.817153c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cash-tree/task-bg.png
// module id = 3OaY
// module chunks = 212